'use client';

import { ReactNode } from 'react';
import { LoadingProvider } from '@/contexts/LoadingContext';
import { LenisProvider } from '@/contexts/LenisContext';
import { TransitionProvider } from '@/contexts/TransitionContext';
import { GsapLenisConnector } from '@/components/client/GsapLenisConnector';
import TransitionOverlay from '@/components/client/TransitionOverlay';
import CookieBanner from '@/components/client/CookieBanner/CookieBanner';
import LoadErrorBanner from '@/components/client/LoadErrorBanner';
import GTMPageView from '@/components/client/GTMPageView';
import { BreakpointProvider } from '@/contexts/BreakpointContext';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <BreakpointProvider>
      <LoadingProvider>
        <LenisProvider>
          <TransitionProvider>
            <GsapLenisConnector />
            <GTMPageView />
            <TransitionOverlay>
              {children}
            </TransitionOverlay>
            <CookieBanner />
            <LoadErrorBanner />
          </TransitionProvider>
        </LenisProvider>
      </LoadingProvider>
    </BreakpointProvider>
  );
}
